import { IClubMeta } from '@features/club/typings-meta';
import { NO_TICKETS_MARK } from '@features/club/utils/event-sections';

import {
  GRAND_PRIX_TICKET,
  PER_EVENT_TICKET_WITH_COUNTER,
  PREMIUM_RCF_TICKET,
  SCHOOL_ELO_OPTIONS,
  SCHOOL_TICKET,
  SUBSCRIPTION_TICKET,
} from '../constants';

// id разделов совпадают с прежними search-параметрами, чтобы не ломать внешние ссылки
export const CHESS_RUSSIAN_META: IClubMeta = {
  eventSections: [
    {
      id: 'rcf',
      title: 'Рейтинг ФШР',
      ticket: PREMIUM_RCF_TICKET,
      entrance: [SUBSCRIPTION_TICKET, PER_EVENT_TICKET_WITH_COUNTER],
      theme: 'premium-rcf-red',
      entranceText: 'Рейтинг ФШР',
      tabs: [
        { id: 'all', label: 'Все' },
        { id: 'tournaments', label: 'Турниры', filter: { seance: false } },
        { id: 'seances', label: 'Сеансы', filter: { seance: true } },
        { id: 'finished', label: 'Архив' },
        { id: 'drafts', label: '✎' },
      ],
    },
    {
      id: 'grandprix',
      title: 'Гран-при РШШ',
      ticket: GRAND_PRIX_TICKET,
      entrance: [SUBSCRIPTION_TICKET, PER_EVENT_TICKET_WITH_COUNTER],
      theme: 'grand-prix',
      entranceText: 'Рейтинг ФШР',
      tabs: [
        { id: 'all', label: 'Все' },
        { id: 'blitz', label: 'Блиц', filter: { clockControl: 'Blitz' } },
        { id: 'rapid', label: 'Рапид', filter: { clockControl: 'Rapid' } },
        { id: 'seances', label: 'Сеансы', filter: { seance: true } },
        { id: 'finished', label: 'Архив' },
        { id: 'drafts', label: '✎' },
      ],
    },
    {
      id: 'school',
      ticket: SCHOOL_TICKET,
      entrance: [],
      filter: { tickets: [SCHOOL_TICKET, NO_TICKETS_MARK] },
      news: true,
      tabs: [
        {
          id: 'school',
          label: 'Ученики РШШ',
          filter: { tickets: [SCHOOL_TICKET] },
          subTabs: [
            { id: 'all', label: 'Все' },
            ...SCHOOL_ELO_OPTIONS.map((o) => ({
              id: o.value,
              label: o.label,
              filter: { tickets: [o.value] },
            })),
          ],
          subParam: 'schoolElo',
        },
        { id: 'public', label: 'Общие', filter: { tickets: [NO_TICKETS_MARK] } },
        { id: 'finished', label: 'Архив' },
        { id: 'drafts', label: '✎' },
      ],
    },
  ],
};
